<template lang="pug" src="./payments.pug"></template>
<style lang="scss" src="./payments.scss" scoped></style>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { numeric } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'
import copyToClipboard from '@/utils/copy'
import scroll from '@/utils/scroll'

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        filters: {
            phoneNumber: null,
            taxiOrderId: null,
            clientId: null,
            orderId: null,
            type: null,
            status: null,
            fromDate: null,
            toDate: null
        },
        sorting: {}
    }),
    validations: {
        filters: {
            clientId: {
                numeric
            },
            taxiOrderId: {
                numeric
            },
            orderId: {
                numeric
            },
            phoneNumber: {
                numeric
            }
        }
    },
    computed: {
        ...mapState({
            payments: state => state.payments.payments,
            isTableLoad: state => state.payments.isLoaded,
            pagination: state => state.payments.pagination,
            appliedFilters: state => state.payments.filters
        }),
        typeSelects: function() {
            const typeSelects = '$vuetify.pages.Payments.autocomplete'
            return ['cardBinding', 'orderPayment', 'deliveryPayment', 'rechargeBalance'].map(it => ({
                text: this.$vuetify.t(`${typeSelects}.${it}`),
                value: it
            }))
        },
        statusSelects: function() {
            const statusSelects = '$vuetify.pages.Payments.autocomplete'
            return ['new', 'success', 'error', 'sandbox'].map(it => ({
                text: this.$vuetify.t(`${statusSelects}.${it}`),
                value: it
            }))
        },
        headers: function() {
            return [
                { text: 'clientId', value: '"clientId"' },
                { text: 'phoneNumber', sortable: false },
                { text: 'taxiOrderId', value: '"taxiOrderId"' },
                { text: 'orderId', value: '"orderId"' },
                { text: 'amount', value: '"amount"' },
                { text: 'status', value: 'status' },
                { text: 'type', value: 'type' },
                { text: 'createdAt', value: '"createdAt"' },
                { text: 'updatedAt', value: '"updatedAt"' },
                { text: 'actions', sortable: false }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.lang.t(`$vuetify.pages.Payments.table.${it.text}`)
            }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getPaymentsByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getPaymentsByPage(this.pagination.page)
    },

    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('payments/SET_PAGINATION', { page: 1, length: null })
        next()
    },
    methods: {
        reset() {
            this.filters = Object.assign({}, {
                phoneNumber: null,
                taxiOrderId: null,
                clientId: null,
                orderId: null,
                type: null,
                status: null,
                fromDate: new Date(+new Date() - 604800000).toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0]
            })
            this.$store.commit('payments/RESET_PAYMENTS')
            this.getPaymentsByPage(this.pagination.page)
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getPaymentsByPage(page, true)
            }
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        getPaymentsByPage(page = 1, isScrollEnable = false, excel = false) {
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                this.$store.dispatch('payments/getPayments', {
                    page,
                    excel,
                    column: this.sorting.sortBy,
                    direction: this.sorting.descending ? 'desc' : 'asc',
                    ...this.appliedFilters
                }).then(_ => {
                    if (isScrollEnable) {
                        scroll(this.$refs.table)
                    }
                })
            }
        },
        submit() {
            this.$store.commit('payments/SET_FILTERS', Object.assign({}, this.filters))
            this.getPaymentsByPage()
        },
        copy(text) {
            if (text) {
                copyToClipboard(text)
            }
        },
        exportToExcel() {
            this.getPaymentsByPage(1, false, true)
        }
    }
}
</script>
